import type { FC } from "react"
import { useRef } from "react"

import { studioToScreen } from "@logic/lib/design"
import { useRecoilValue } from "recoil"
import styled from "styled-components"

import { findProjectedMouseState } from "~/hooks/useMousePosition"

import { rulerLengthState } from "../../state/elements/transactions/dragBox/dragRuler"
import { startPointState } from "../../state/inputs"
import { zoomState } from "../../state/view"

const StyledRuler = styled.g`
  pointer-events: none;
  text {
    font-size: 18px;
    fill: white;
    stroke: black;
    stroke-width: 6px;
    paint-order: stroke;
  }
`

export const Ruler: FC = () => {
  const p1Pos = useRecoilValue(startPointState)
  const length = useRecoilValue(rulerLengthState)
  const zoom = useRecoilValue(zoomState)
  const p1 = p1Pos ? studioToScreen.point(p1Pos, zoom) : null
  const previewNode = useRecoilValue(
    findProjectedMouseState([`Studio`, `Studio`]),
  )
  const nodeRef = useRef(null)

  return (
    <>
      {p1 && (
        <StyledRuler ref={nodeRef} style={{ pointerEvents: `none` }}>
          <line
            x1={p1.x}
            y1={p1.y}
            x2={previewNode.x}
            y2={previewNode.y}
            stroke={`#fff`}
            strokeWidth={3}
          />
          <line
            x1={p1.x}
            y1={p1.y}
            x2={previewNode.x}
            y2={previewNode.y}
            stroke="var(--gold)"
            strokeWidth={2}
            strokeDasharray={`4 9`}
          />
          <text x={(p1.x + previewNode.x) / 2} y={(p1.y + previewNode.y) / 2}>
            {inchesToFeet(length)}
          </text>
          <circle cx={p1.x} cy={p1.y} r={5} fill="#fff" />
        </StyledRuler>
      )}
    </>
  )
}

// inches to feet and inches
const inchesToFeet = (length: number) => {
  const feet = Math.floor(length / 12)
  const inches = Math.floor(length % 12)
  if (feet < 0) {
    return `${length}"`
  }
  if (inches === 0) {
    return `${feet}'`
  }

  return `${feet}' ${inches}"`
}
